<template>
  <div class="r-fabric" @mouseenter="mouseenter" @mouseleave="mouseleave">
<!--    <img class="fabric" :src="config.imagePath" alt="" />-->
    <img class="fabric" @error="imgError" v-if="pictureShow" :src="config.imagePath" alt="" />
    <div v-if="!pictureShow" class="img-none-box">
      <img class="img-none"  src="../assets/images/f-none.png" alt="" />
      <div class="img-none-font">{{$t('nOFabric')}}</div>
    </div>
    <div class="fabric-msg">
      <div class="fabric-name">{{config.fabricCode}}</div>
      <div class="fabric-component" style="color:white">{{config.fabricProName}}</div>
    </div>
    <div v-if="show" class="iconfont iconsousuo common-hover" @click="fabric"></div>
  </div>
</template>

<script>
export default {
  name: "r-fabric",
  data() {
    return {
      pictureShow:true,
      show:false
    };
  },
  props:{
    config:Object,
    index:Number
  },
  methods:{
    // 移入
    mouseenter(){
      this.show = true
    },
    //图片错误
    imgError(e) {
      this.pictureShow = false
    },
    // 移出
    mouseleave(){
      this.show = false
    },
    // 点击查看
    fabric(){
      this.$emit('fabric',this.config,this.index)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-fabric {
  width: 126px;
  height: 160px;
  border-radius: 5px;
  position: relative;
  margin-bottom: 20px;
  .iconsousuo{
    width: 48px;
    height: 48px;
    background-color: rgba(255,255,255,.3);
    font-size: 20px;
    line-height: 48px;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    color:#fff;
    border-radius: 50%;
  }
  .img-none-box{
    position: absolute;
    left:0;
    text-align: center;

    right: 0;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .img-none{
    width: 120px;
    height: 120px;
    // margin: 80px auto 15px;
  }
  .fabric {
    width: 126px;
    height: 160px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
  }
  .fabric-msg {
    width: 126px;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), #000000);
    border-radius: 0 0 5px 5px;
    .fabric-name {
      font-size: 14px;
      font-family: Arial, Arial-BoldMT;
      font-weight: BoldMT;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 9px 0 3px;
    }
    .fabric-component {
      font-size: 12px;
      font-family: ArialMT;
      text-align: center;
      color: #17ab00;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-fabric.vue